<ng-container *ngIf="action$ | async as action">
  <p-button
    icon="pi pi-hidden"
    [ngClass]="action.name"
    [label]="action.description"
    ntapDebounceClick
    (onClick)="executeAction($event)"
    [disabled]="(isDisabled$ | async) ?? true"
    [pTooltip]="action.tooltip ?? ''"
    tooltipPosition="left"
  ></p-button>
</ng-container>
